const CLAIM_YOUR_LISTING_COOKIES = {
  HAS_CLOSED_MODAL: 'ZRM_hasClosedClaimYourListingsModal',
  HAS_CLOSED_CLAIM_BANNER: 'ZRM_hasClosedClaimYourListingsBanner',
  HAS_CLOSED_UPGRADE_BANNER: 'ZRM_hasClosedUpgradeToAdPackageBanner',
  HAS_CLOSED_CLAIM_MORE_BANNER: 'ZRM_hasClosedClaimMoreListingsBanner',
  HAS_CLOSED_CLAIM_MORE_MODAL: 'ZRM_hasClosedClaimMoreListingsModal',
  EXPIRATION: 400, // max expiration date
};

const SPOTLIGHT_LISTINGS_COOKIES = {
  HAS_CLOSED_SPOTLIGHT_LISTINGS_MODAL: 'ZRM_hasClosedSpotlightListingsModal',
  EXPIRATION: 400, // max expiration date
};

const MEDIA_CREDITS_COOKIES = {
  HAS_CLOSED_PAGE_BANNER: 'ZRM_hasClosedMediaCreditsPageBanner',
  HAS_CLOSED_SECTION_BANNER: 'ZRM_hasClosedMediaCreditsSectionBanner',
  EXPIRATION: 400,
};

export { CLAIM_YOUR_LISTING_COOKIES, MEDIA_CREDITS_COOKIES, SPOTLIGHT_LISTINGS_COOKIES };
